import { render, staticRenderFns } from "./OrderScroll.vue?vue&type=template&id=032a1d46&scoped=true&"
import script from "./OrderScroll.vue?vue&type=script&lang=js&"
export * from "./OrderScroll.vue?vue&type=script&lang=js&"
import style0 from "./OrderScroll.vue?vue&type=style&index=0&id=032a1d46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032a1d46",
  null
  
)

export default component.exports